// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
const {ccclass, property} = cc._decorator;

const c_gold = 100000000;
@ccclass
export default class SuperPowerSelect10 extends BasePopUpLayer {
   
    @property(cc.Node)
    nodeGoods: cc.Node = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        cc.tween(this.node)
        .delay(0.1)
        .call(this.onClickConfirm.bind(this))
        .start();
    }

    onClickConfirm() {
        O1HD.getServices().userSrv.setCoins(c_gold, true, this.nodeGoods);
        this.destroyNode();
        this._carryData.parent.showEndUI(null, false, 4);
    }

    // update (dt) {}
}
